import { render, staticRenderFns } from "./ShipmentsAnalytics.vue?vue&type=template&id=1232f5ea&"
import script from "./ShipmentsAnalytics.vue?vue&type=script&lang=js&"
export * from "./ShipmentsAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports